export const ignoreInScreenshotsDataAttribute = {
  'data-test-ignore': '',
};
